import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GridColDef } from '@mui/x-data-grid';
import { UPDataGrid } from 'components/data-grid';
import { useTranslation } from 'react-i18next';
import UPButton from 'components/button';
import { useAppSelector } from 'store';
import { affectedCompaniesSelector } from 'store/selectors/wage-indexation-selectors';
import { previewAffactedCompaniesAction, updateWageIndexationAction } from 'store/actions/wage-indexation-actions';
import {
  MENU__COMPANY,
  WAGE_INDEXATION__AFFECTED_CONTRACTS_COUNT,
  WAGE_INDEXATION__ALL_AFFECTED_COMPANIES,
  WAGE_INDEXATION__INDEXATION_SOURCE,
  WAGE_INDEXATION__PREVIOUS_STEP,
  WAGE_INDEXATION__SAVE_INDEXATION,
} from 'translations/constants';
import {
  WageIndexationFlowButtonContainer,
  WageIndexationFlowCard,
  WageIndexationFlowStepContainer,
  WageIndexationGridContainer,
} from './styles';
import { WageIndexationFlowContext } from './WageIndexation';
import { UpdateWageIndexationModel } from './types';
import ConfirmIndexationModal from './modals/ConfirmIndexationModal';

const AffectedCompaniesOverViewGrid: React.FC = () => {
  const {
    onClickPreviousStep,
    activeStep,
    isIndexationPerformed,
    updatedMinimumWages,
    companyExceptions,
    wageIndexationProps,
    filtersSet,
  } = useContext(WageIndexationFlowContext);

  const affectedCompaniesData = useAppSelector(affectedCompaniesSelector);
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [rowOnHover, setRowOnHover] = useState<number>();
  const [confirmationModalOpen, setConfirmationModalOpen] = useState<boolean>(false);

  useEffect(() => {
    if (filtersSet && activeStep > 0) {
      dispatch(
        previewAffactedCompaniesAction({
          jointCommissionId: +wageIndexationProps.jointCommissionId,
          collarType: wageIndexationProps.collarType,
          startDate: wageIndexationProps.startDate,
          endDate: wageIndexationProps.endDate,
        }),
      );
    }
  }, [wageIndexationProps, filtersSet, activeStep, dispatch]);

  const columns: GridColDef[] = [
    { field: 'id', headerName: '', hide: true },
    { field: 'companyName', headerName: t(MENU__COMPANY), width: 300 },
    { field: 'indexationSource', headerName: t(WAGE_INDEXATION__INDEXATION_SOURCE), width: 400 },
    {
      field: 'affectedContracts',
      headerName: t(WAGE_INDEXATION__AFFECTED_CONTRACTS_COUNT),
      width: 300,
      align: 'center',
    },
  ];

  const onConfirmIndexation = () => {
    const data: UpdateWageIndexationModel = {
      wageIndexationFilterProps: wageIndexationProps,
      updatedMinimumWages,
      companyExceptions,
    };

    dispatch(updateWageIndexationAction({ data }));
    setConfirmationModalOpen(false);
    isIndexationPerformed(true);
  };
  const onSaveExceptionValues = () => {
    setConfirmationModalOpen(true);
  };

  return (
    <WageIndexationFlowStepContainer activeStep={activeStep}>
      <WageIndexationFlowCard>
        <h5 style={{ marginTop: 0, marginBottom: 0 }}>{t(WAGE_INDEXATION__ALL_AFFECTED_COMPANIES)}</h5>
        <WageIndexationGridContainer>
          <UPDataGrid
            rows={affectedCompaniesData}
            columns={columns}
            setRowOnHover={setRowOnHover}
            withCheckboxes={false}
          />
        </WageIndexationGridContainer>
        <WageIndexationFlowButtonContainer>
          <UPButton text={t(WAGE_INDEXATION__PREVIOUS_STEP)} onClick={onClickPreviousStep} outlined />
          <UPButton text={t(WAGE_INDEXATION__SAVE_INDEXATION)} onClick={onSaveExceptionValues} />
        </WageIndexationFlowButtonContainer>
      </WageIndexationFlowCard>
      {confirmationModalOpen && (
        <ConfirmIndexationModal
          isOpen={confirmationModalOpen}
          onClose={() => setConfirmationModalOpen(false)}
          onConfirm={onConfirmIndexation}
        />
      )}
    </WageIndexationFlowStepContainer>
  );
};

export default AffectedCompaniesOverViewGrid;
